(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aj-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aj-infinite-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aj-infinite-scroll')) {
    customElements.define('aj-infinite-scroll', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        if (this.dataset.pageType !== 'collection' && !(this.dataset.pageType === 'search' && this.dataset.search === 'true')) return;
        document.documentElement.classList.add('aj-scroll-enabled');
        this.onInput = (event) => {
          if (event.type === 'input' && event.target.closest('facet-filters-form')) this.pause();
          if (event.type === 'click' && event.target.closest('facet-remove a')) this.pause();
        };
        this.onHistory = () => {
          if (location.pathname + location.search !== this.view) this.pause();
        };
        document.addEventListener('input', this.onInput, true);
        document.addEventListener('click', this.onInput, true);
        window.addEventListener('popstate', this.onHistory);
        this.changes = new MutationObserver(() => this.sync());
        this.changes.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
        this.sync();
      }
      disconnectedCallback() {
        document.documentElement.classList.remove('aj-scroll-enabled');
        this.changes?.disconnect();
        document.removeEventListener('input', this.onInput, true);
        document.removeEventListener('click', this.onInput, true);
        window.removeEventListener('popstate', this.onHistory);
        this.cleanup();
      }
      pause() {
        this.paused = true;
        this.controller?.abort();
      }
      cleanup() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controls?.remove();
        if (this.pagination) {
          this.pagination.hidden = false;
          this.pagination.classList.remove('aj-scroll-pagination');
        }
      }
      nextPage(root) {
        const navigation = root.querySelector('.pagination');
        const current = Number(navigation?.querySelector('[aria-current="page"]')?.textContent.trim());
        if (!current) return null;
        for (const link of navigation.querySelectorAll('a[href]')) {
          const url = new URL(link.getAttribute('href'), location.href);
          if (url.origin === location.origin && Number(url.searchParams.get('page')) === current + 1) return url;
        }
        return null;
      }
      sync() {
        const container = document.getElementById('ProductGridContainer');
        const grid = container?.querySelector('ul.product-grid');
        if (grid === this.grid) return;
        this.cleanup();
        this.grid = grid;
        this.paused = false;
        this.busy = false;
        this.loads = 0;
        this.next = container && this.nextPage(container);
        if (!grid || !this.next) return;
        this.pagination = container.querySelector('.pagination-wrapper');
        if (!this.pagination) return;
        this.view = location.pathname + location.search;
        this.controls = document.createElement('div');
        this.controls.className = 'aj-scroll';
        this.controls.style.setProperty('--aj-scroll-radius', this.dataset.radius + 'px');
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'aj-scroll__button';
        this.button.textContent = this.dataset.more;
        this.button.addEventListener('click', () => this.load(true));
        this.status = document.createElement('p');
        this.status.className = 'aj-scroll__status';
        this.status.setAttribute('role', 'status');
        this.status.setAttribute('aria-live', 'polite');
        this.controls.append(this.button, this.status);
        this.pagination.after(this.controls);
        this.pagination.classList.add('aj-scroll-pagination');
        this.pagination.hidden = true;
        if (this.dataset.mode === 'auto' && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) this.load(false);
          }, { rootMargin: '0px 0px 300px 0px' });
          this.observer.observe(this.controls);
        }
      }
      async load(manual) {
        const limit = Number(this.dataset.limit);
        if (this.busy || this.paused || !this.next || !this.grid?.isConnected) return;
        if (!manual && limit > 0 && this.loads >= limit) return;
        if (location.pathname + location.search !== this.view || this.grid.closest('.collection.loading')) return;
        this.busy = true;
        this.button.disabled = true;
        this.status.textContent = this.dataset.loading;
        const grid = this.grid;
        const controls = this.controls;
        const requested = new URL(this.next);
        const url = new URL(requested);
        url.searchParams.set('section_id', grid.closest('[data-id]').dataset.id);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Unable to load products');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.querySelector('#ProductGridContainer ul.product-grid');
          if (!incoming || !incoming.children.length) throw new Error('Missing product grid');
          if (this.paused || this.grid !== grid || !grid.isConnected || location.pathname + location.search !== this.view) return;
          const first = incoming.firstElementChild;
          const next = this.nextPage(html);
          if (next && Number(next.searchParams.get('page')) <= Number(requested.searchParams.get('page'))) throw new Error('Invalid next page');
          grid.append(...incoming.children);
          this.next = next;
          this.loads++;
          this.status.textContent = next ? '' : this.dataset.done;
          this.button.hidden = !next;
          if (!next) this.observer?.disconnect();
          if (manual) {
            first.setAttribute('tabindex', '-1');
            first.focus({ preventScroll: true });
          }
          document.dispatchEvent(new CustomEvent('aj:products-appended', { detail: { grid } }));
        } catch (error) {
          if (this.controls !== controls || this.paused) return;
          this.status.textContent = this.dataset.error;
          this.observer?.disconnect();
          this.pagination.hidden = false;
        } finally {
          clearTimeout(timeout);
          if (this.controls === controls) {
            this.busy = false;
            this.button.disabled = false;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aj-product-labels"]) return;
  try {
    
(() => {
  let queued = false;
  function readConfig() {
    const source = document.querySelector('[data-aj-label-config]');
    if (!source) return null;
    try { return JSON.parse(source.textContent); } catch (_) { return null; }
  }
  function matches(label, target) {
    if (!label.enabled || !label.text || !label.text.trim()) return false;
    let collections, tags;
    try {
      collections = JSON.parse(target.dataset.ajCollections || '[]');
      tags = JSON.parse(target.dataset.ajTags || '[]');
    } catch (_) { return false; }
    const tag = (label.tag || '').trim();
    return (label.collections || []).some(handle => collections.includes(handle)) ||
      (label.products || []).some(id => String(id) === target.dataset.ajId) ||
      (tag !== '' && tags.includes(tag));
  }
  function paint() {
    queued = false;
    const config = readConfig();
    if (!config) { document.querySelectorAll("[data-aj-label-target]").forEach(target => { target.replaceChildren(); delete target.dataset.ajSignature; }); return; }
    const signature = JSON.stringify(config);
    document.querySelectorAll('[data-aj-label-target]').forEach(target => {
      const targetSignature = signature + target.dataset.ajId + target.dataset.ajCollections + target.dataset.ajTags;
      if (target.dataset.ajSignature === targetSignature) return;
      target.dataset.ajSignature = targetSignature;
      target.replaceChildren();
      if (!config.enabled) return;
      let promotionShown = false;
      let count = 0;
      for (const label of config.labels || []) {
        if (count >= (config.maxLabels || 3)) break;
        if (!matches(label, target)) continue;
        if (label.group === 'promotion' && promotionShown) continue;
        if (label.group === 'promotion') promotionShown = true;
        const badge = document.createElement('span');
        badge.className = 'aj-product-label';
        badge.dataset.ajLabelId = label.id;
        badge.textContent = label.text;
        badge.dir = /[\u0590-\u08ff]/.test(label.text) ? 'rtl' : 'ltr';
        badge.style.backgroundColor = label.background || '#e4bd88';
        badge.style.color = label.color || '#000000';
        if (Number(label.font) > 0) badge.style.setProperty('--aj-label-font', label.font + 'px');
        if (Number(label.mobileFont) > 0) badge.style.setProperty('--aj-label-mobile-font', label.mobileFont + 'px');
        if (label.weight && label.weight !== 'inherit') badge.style.setProperty('--aj-label-weight', label.weight);
        target.append(badge);
        count++;
      }
      if (count) {
        target.parentElement.classList.add('aj-label-host');
        target.dataset.position = config.position || 'left';
        target.style.setProperty('--aj-label-font', (config.font || 13) + 'px');
        target.style.setProperty('--aj-label-mobile-font', (config.mobileFont || 12) + 'px');
        target.style.setProperty('--aj-label-weight', config.weight || '700');
        target.style.setProperty('--aj-label-gap', (config.gap ?? 5) + 'px');
        target.style.setProperty('--aj-label-offset', (config.offset ?? 8) + 'px');
        target.style.setProperty('--aj-label-radius', (config.radius || 0) + 'px');
      }
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paint);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue, {once:true});
  else queue();
  document.addEventListener('shopify:section:load', queue);
  document.addEventListener('shopify:section:unload', queue);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-aj-label-target],[data-aj-label-config]') ||
      node.querySelector('[data-aj-label-target],[data-aj-label-config]'))))) queue();
  }).observe(document.documentElement, {childList:true, subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
